export const AVAILABLE_MEASUREMENTS = [['weight'], ['hip'], ['waist'], ['chest']];
